import React, { useEffect, useState } from "react";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Analytics } from "@vercel/analytics/react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Projects from "./pages/Projects";
import Sidebar from "./components/Sidebar";
import Certificates from "./pages/Certificates";
import Contact from "./pages/Contact";
import Footer from "./components/Footer";

const postsBaseUrl = process.env.REACT_APP_POSTS_BASE_URL;

const getPostUrl = () => {
  const postKey = new URLSearchParams(window.location.search).get("post");
  const fileName = `${postKey || "post1"}.txt`;

  if (postsBaseUrl) {
    return `${postsBaseUrl.replace(/\/$/, "")}/${fileName}`;
  }

  return `/posts/${fileName}`;
};

function App() {
  const [text, setText] = useState("");

  useEffect(() => {
    let inactivityTimer;

    const resetTimer = () => {
      clearTimeout(inactivityTimer);
      inactivityTimer = setTimeout(() => {
        window.location.reload();
      }, 10 * 60 * 1000);
    };

    window.addEventListener("mousemove", resetTimer);
    window.addEventListener("keypress", resetTimer);

    resetTimer();

    fetch(getPostUrl(), { cache: "no-store" })
      .then((res) => {
        if (!res.ok) {
          throw new Error(`Unable to load post: ${res.status}`);
        }

        return res.text();
      })
      .then((data) => setText(data))
      .catch(console.error);

    return () => {
      window.removeEventListener("mousemove", resetTimer);
      window.removeEventListener("keypress", resetTimer);
      clearTimeout(inactivityTimer);
    };
  }, []);

  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            <div className="App with-sidebar">
              <Analytics />

              <div className="app-content">
                <Sidebar />

                <main>
                  <h1>Welcome to my site!</h1>
                  <p className="intro">{text}</p>

                  <div className="certifications">
                    <h1>Featured Certifications</h1>
                    <ul>
                      <li>
                        <a
                          href="https://1drv.ms/b/c/49f4fff65043252b/ESslQ1D2__QggEkh2wAAAAAB5m1r7_pKxI8lB5e16ygs0A?e=IZf3a0"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <img
                            src="./img/codeacademy-logo.png"
                            alt="Codeacademy logo"
                            loading="eager"
                            id="codeacademy-logo"
                          />
                          Front-End Engineer
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://coursera.org/share/2847c3157a1fbf0278fb90f892ba4a8b"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <img
                            src="./img/ibm-logo2.jpeg"
                            alt="IBM logo"
                            loading="eager"
                            id="ibm-logo"
                          />
                          IBM Front-End Developer
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://coursera.org/share/78da9e81910647cd25fd4125dafbb3fa"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <img
                            src="./img/microsoft-logo.jpeg"
                            alt="Microsoft logo"
                            loading="eager"
                            id="microsoft-logo"
                          />
                          Microsoft IT Support Specialist
                        </a>
                      </li>
                    </ul>
                  </div>
                </main>

                <section className="featured">
                  <h1>Featured Project:</h1>

                  <article className="featured-card">
                    <div className="featured-preview">
                      <a
                        href="https://campus-edu.vercel.app"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src="./img/campusedu.png"
                          alt="CampusEdu"
                          className="project-img"
                          loading="eager"
                          id="campusedu"
                        />
                      </a>
                    </div>

                    <div className="featured-copy">
                      <h3>CampusEdu</h3>
                      <p className="featured-subtitle">
                        A student-focused learning platform concept that blends
                        educational discovery, streamlined navigation, and
                        accessible design for modern academic support.
                      </p>
                    </div>
                  </article>
                </section>
              </div>

              <Footer />
            </div>
          }
        />

        <Route path="/projects" element={<Projects />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/certificates" element={<Certificates />} />
      </Routes>
    </Router>
  );
}

export default App;
